(function () {
  function activateVideo(trigger) {
    var card = trigger.closest('[data-bb-pdp-video]');
    if (!card) return;

    var iframe = document.createElement('iframe');
    iframe.src = trigger.dataset.videoSrc;
    iframe.title = trigger.dataset.videoTitle || trigger.getAttribute('aria-label') || 'Product video';
    iframe.loading = 'lazy';
    iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
    iframe.allowFullscreen = true;
    iframe.className = 'bb-pdp-video-card__iframe';

    card.textContent = '';
    card.appendChild(iframe);
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-bb-pdp-video-trigger]');
    if (!trigger) return;

    event.preventDefault();
    activateVideo(trigger);
  });
})();
